export interface AdditionalData {
  notes?: string;
  membership?: string;
  title?: string;
  [key: string]: unknown;
}

export function parseAdditionalData(raw?: string | null): AdditionalData {
  if (!raw || raw.trim() === '') return {};
  try {
    const first: unknown = JSON.parse(raw);
    const parsed: unknown = typeof first === 'string' ? JSON.parse(first) : first;
    return parsed && typeof parsed === 'object' ? (parsed as AdditionalData) : {};
  } catch {
    return {};
  }
}

export function serializeAdditionalData(data: AdditionalData): string {
  return JSON.stringify(JSON.stringify(data));
}
